var path = 'app/scripts/modules/azure/serverGroup/configure/wizard/advancedSettings/advancedSettings.html';
var html = "  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <azure-server-group-advanced-settings-selector command=\"command\"></azure-server-group-advanced-settings-selector>\n    </div>\n  </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/azure/serverGroup/configure/wizard/advancedSettings/advancedSettings.html
// module id = 1682
// module chunks = 0